export default {"src":"/_next/static/media/logout.7e05a4a8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};